export default __webpack_public_path__ + "img/Montserrat-ExtraLight_ddc3ab5.ttf";